import request from './services/axios.js'
export default {
  getSpecificWordLibByPage: (params) => {
    return request({
      params,
      url: '/ebook/specificWordLib/getSpecificWordLibByPage',
      method: 'get'
    })
  },
  addSpecificWordLib: (params) => {
    return request({
      params,
      url: '/ebook/specificWordLib/addSpecificWordLib',
      method: 'get'
    })
  },
  delSpecificWordLib: (params) => {
    return request({
      params,
      url: '/ebook/specificWordLib/delSpecificWordLib',
      method: 'get'
    })
  },
  getSpecificWordByPage: (params) => {
    return request({
      params,
      url: '/ebook/specificWordLib/getSpecificWordByPage',
      method: 'get'
    })
  },
  addSpecificWord: (params) => {
    return request({
      params,
      url: '/ebook/specificWordLib/addSpecificWord',
      method: 'get'
    })
  },
  importSpecificWordLib: (params) => {
    return request({
      data: params,
      url: '/ebook/specificWordLib/importSpecificWordLib',
      method: 'post'
    })
  },
  editSpecificWord: (params) => {
    return request({
      params,
      url: '/ebook/specificWordLib/editSpecificWord',
      method: 'get'
    })
  },
  delSpecificWord: (params) => {
    return request({
      params,
      url: '/ebook/specificWordLib/delSpecificWord',
      method: 'get'
    })
  }
}
